import { useQuery } from "react-query";
import {
  claimLegacyTitleLinksForComponent,
  fetchUserLinksForBoundComponent,
} from "../../../../../../Utils/SupabaseServices/UserLinksDatabase";
import { supabase } from "../../../../../../config/supabaseClient";
import { getUserLinksTypeForSurface } from "../../../../../../Utils/StayUpToDate/componentSurface";

export function useLoadUserLinks(
  user_id: any,
  collection_name: any,
  from: any,
  componentId?: string | null
) {
  const fetchCollectionsWithLinks = async () => {
    const linksType = getUserLinksTypeForSurface(from);
    const boundId = String(componentId || "").trim();

    if (boundId) {
      return fetchUserLinksForBoundComponent({
        user_id,
        collectionName: String(collection_name || "").trim(),
        from,
        componentId: boundId,
      });
    }

    const { data: collections, error: collectionsError } = await supabase
      .from("user_links")
      .select("*")
      .eq("collection_name", collection_name)
      .eq("user_id", user_id)
      .eq("type", linksType)
      .eq("status", "active")
      .order("index");

    if (collectionsError) {
      throw new Error(collectionsError.message);
    }

    return collections;
  };

  return useQuery(
    ["userLinks", user_id, collection_name, from, componentId || ""],
    fetchCollectionsWithLinks,
    {
      refetchOnWindowFocus: false,
    }
  );
}

export { claimLegacyTitleLinksForComponent };
